module.exports = __webpack_public_path__ + "static/media/video.c04870ed.png";